import type { IForgotPasswordLocale } from '@/Pages/Onboard/Forgot/Locale/ForgotPassword.locale';

const ptBR: IForgotPasswordLocale = {
  title: 'Esqueceu sua senha?',
  subtitle:
    'Sem problemas! Informe o e-mail associado à sua conta e enviaremos um link para redefinir sua senha.',
  email: {
    label: 'Email',
    placeholder: 'Digite seu endereço de email',
    error: 'Por favor, digite um endereço de email válido',
  },
  button: {
    sendLink: 'Enviar Link de Redefinição',
    backToLogin: 'Voltar ao Login',
    sendingLink: 'Enviando...',
  },
  success: {
    title: 'Verifique seu email',
    message:
      'Enviamos um link de redefinição de senha. Verifique sua caixa de entrada e siga as instruções para redefinir sua senha.',
  },
};

export { ptBR };
